import { render, staticRenderFns } from "./documents-index.vue?vue&type=template&id=43eb83c7&scoped=true"
import script from "./documents-index.vue?vue&type=script&lang=js"
export * from "./documents-index.vue?vue&type=script&lang=js"
import style0 from "./documents-index.vue?vue&type=style&index=0&id=43eb83c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43eb83c7",
  null
  
)

export default component.exports